module.exports = __webpack_public_path__ + "static/media/nipa-huts.56202e8f.jpg";